'use client';

import * as stylex from '@stylexjs/stylex';
import { Dialog } from '@base-ui/react/dialog';
import { PageSectionsLandingHeroConversionForm } from '@/tina/__generated__/types';
import { lazy, Suspense } from 'react';
import '../../styles/tokens.stylex';
import { color, borderRadius, spacing, VP, size, shadow } from '../../styles/tokens.stylex';
import { AnimatePresence, motion } from 'motion/react';
import { DialogLoading } from './DialogLoading';
import { StepsProvider } from '../Form/StepsProvider';
import { SteppedFormHandle } from './dialogHandle';
import { DialogNavigator } from './DialogNavigator';
import { SuccessNavigator } from './SuccessNavigator';
import { SteppedFormHeader } from './SteppedFormHeader';
const TEST_DIALOG_OPEN = false;
const SteppedFormLazyBody = lazy(() => import('./SteppedFormContent').then(m => ({
  default: m.SteppedFormLazyBody
})));
type SteppedFormProps = {
  data: PageSectionsLandingHeroConversionForm;
  dialogOpen: boolean;
  setDialogOpen: (open: boolean) => void;
  initialStep?: string;
  syncStepSearchParamOnOpen?: boolean;
  onStepSearchParamCleared?: () => void;
};
export function SteppedForm({
  data,
  dialogOpen,
  setDialogOpen,
  initialStep,
  syncStepSearchParamOnOpen,
  onStepSearchParamCleared
}: SteppedFormProps) {
  return <Dialog.Root open={TEST_DIALOG_OPEN || dialogOpen} onOpenChange={setDialogOpen} handle={SteppedFormHandle}>
      <AnimatePresence>
        <Dialog.Portal>
          <Dialog.Backdrop className="x1dmgsgi xn3b370 xixxii4 x1vjfegm x1dr59a3 xu96u03 x13vifvy xn9wirt" forceRender render={<motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} />} />

          <Dialog.Viewport>
            <Dialog.Popup render={<motion.div layoutId="conversion-form-canvas" layout transition={{
            type: 'spring',
            visualDuration: 0.3,
            bounce: 0.24
          }} exit={{
            opacity: 0,
            y: 100
          }} />} className="x10a8y8t xwj3lae x2u8bby x1uzkno1 xvueqy4 xh63mhl xsbhbp9 x1xt9a6s xrvj5dj x16p6thf xixxii4 xhtitgo x1ur3sa3">
              <StepsProvider initialStep={initialStep}>
                {syncStepSearchParamOnOpen ? <DialogNavigator dialogOpen={dialogOpen} onStepSearchParamCleared={onStepSearchParamCleared} /> : null}
                <SuccessNavigator />
                <SteppedFormHeader data={data} />
                <Suspense fallback={<DialogLoading />}>
                  <SteppedFormLazyBody data={data} />
                </Suspense>
              </StepsProvider>
            </Dialog.Popup>
          </Dialog.Viewport>
        </Dialog.Portal>
      </AnimatePresence>
    </Dialog.Root>;
}